/**
 * Appends Contentful Image API parameters to a URL for optimization.
 */
export function optimizeContentfulUrl(
    url: string | undefined | null,
    options: {
        width?: number
        quality?: number
        format?: 'webp' | 'avif' | 'jpg' | 'png'
    } = {},
): string | undefined {
    if (!url) return undefined

    const { width, quality = 85, format = 'webp' } = options
    const separator = url.includes('?') ? '&' : '?'
    const params: string[] = []

    if (width) params.push(`w=${width}`)
    params.push(`q=${quality}`)
    params.push(`fm=${format}`)

    return `${url}${separator}${params.join('&')}`
}

/**
 * Wraps a Contentful URL in CSS url() with optimization params.
 */
export function optimizedBgUrl(
    url: string | undefined | null,
    width: number,
): string | undefined {
    const optimized = optimizeContentfulUrl(url, { width })
    return optimized ? `url(${optimized})` : undefined
}
